var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container checkbox-grid"},_vm._l((_vm.passIn),function(ref,index){
var label = ref.label;
var value = ref.value;
var defaultValue = ref.defaultValue;
return _c('div',{key:(label + "-" + index),staticClass:"text-sm flex align-center"},[_c('Checkbox',{attrs:{"defaultValue":defaultValue,"label":label,"value":value},on:{"input":_vm.onCheck},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('img',{staticClass:"p-1 w-4",attrs:{"src":("/svg/techstack/" + value + ".svg")}})]},proxy:true}],null,true)})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }